export const rolePages = {
  SYSTEMBIGADMIN: [
    "/dashboard",
    "/pos",
    "/TaghezScreen",
    "/Deliverypage",
    "/invoices",
    "/reports",
    "/Statics",
    "/customers",
    "/menu",
    "/staff",
    "/users",
    "/settings",
    "/accounts",
    "/tables",
    "/delivery",
    "/takeaway",
    "/reservation",
  ],
  manager: [
   "/dashboard",
    "/pos",
    "/TaghezScreen",
    "/Deliverypage",
    "/invoices",
    "/reports",
    "/Statics",
    "/customers",
    "/menu",
    "/staff",
    "/users",
    "/settings",
    "/tables",
    "/delivery",
    "/takeaway",
    "/reservation",
  ],
  cashier: [
    "/pos",
    "/invoices",
    "/customers",
  ],
  kitchen: [
    "/TaghezScreen", // شاشة التجهيز
  ],
  delivery: [
    "/Deliverypage",
  ],
  captainOrder: [
    "/pos",
    "/customers",

  ],
  accountant: [
    "/accounts",
    "/reports",
    "/Statics",
  ],
};
